import { useMessageBoxStore } from '../stores/messageBox';
import type { MessageBoxInput } from '../stores/messageBox';

/**
 * Promise-based replacement for the native browser `confirm` / `alert` / `prompt`
 * dialogs. Rendered by the global <MessageBoxHost /> in App.vue.
 *
 * Usage (in an async function):
 *   const { confirm } = useMessageBox();
 *   if (!(await confirm(t('...')))) return;      // plain string
 *   if (!(await confirm({ message: t('...'), variant: 'danger' }))) return;  // options
 */
export function useMessageBox() {
  const store = useMessageBoxStore();

  function confirm(input: MessageBoxInput) {
    return store.confirm(input);
  }

  function alert(input: MessageBoxInput) {
    return store.alert(input);
  }

  function prompt(input: MessageBoxInput) {
    return store.prompt(input);
  }

  return { confirm, alert, prompt };
}
